import Vue from 'vue';

import LayoutHeader from '@/components/layout/Header';
import LayoutMenu from '@/components/layout/Menu';
import LayoutMenuOverlay from '@/components/layout/MenuOverlay';
import LayoutSocial from '@/components/layout/Social';
import LayoutFooter from '@/components/layout/Footer';
import LayoutFaciliti from '@/components/layout/Faciliti';
import LayoutCover from '@/components/layout/Cover';

import PageHome from '@/components/pages/Home';
import PageNews from '@/components/pages/News';
import PageNewsDetail from '@/components/pages/NewsDetail';
import PagePhototheque from '@/components/pages/Phototheque';
import PagePhotothequeDetail from '@/components/pages/PhotothequeDetail';
import PageContact from '@/components/pages/Contact';
import PageAbout from '@/components/pages/About';
import NotFound from '@/components/pages/NotFound';
import CmsTemplate from '@/components/pages/CmsTemplate';

import HeroCard from '@/components/HeroCard';
import Card from '@/components/Card';
import TwitterCard from '@/components/TwitterCard';
import RoundedButton from '@/components/RoundedButton';
import ArticleContent from '@/components/ArticleContent';
import CmsContent from '@/components/CmsContent';
import ShareBar from '@/components/ShareBar';
import PhotothequeCategory from '@/components/phototheque/Category';
import PhotothequeCard from '@/components/phototheque/Card';
import Mantel from '@/components/Mantel';
import MediaCard from '@/components/phototheque/MediaCard';
import ContactDetails from '@/components/ContactDetails';
import AboutStatCard from '@/components/about/StatCard';
import AboutStatHeroCard from '@/components/about/StatHeroCard';
import AboutTimeline from '@/components/about/Timeline';
import AboutTimelineItem from '@/components/about/TimelineItem';

import '@/assets/styles/main.scss';

Vue.config.productionTip = false;

new Vue({
    components: {
        LayoutHeader,
        LayoutMenu,
        LayoutMenuOverlay,
        LayoutFooter,
        LayoutSocial,
        LayoutFaciliti,
        LayoutCover,

        PageHome,
        PageNews,
        PageNewsDetail,
        PagePhototheque,
        PagePhotothequeDetail,
        PageContact,
        PageAbout,
        NotFound,
        CmsTemplate,

        HeroCard,
        Card,
        TwitterCard,
        RoundedButton,
        ArticleContent,
        CmsContent,
        ShareBar,
        Mantel,

        PhotothequeCategory,
        PhotothequeCard,
        MediaCard,

        ContactDetails,

        AboutStatCard,
        AboutStatHeroCard,
        AboutTimeline,
        AboutTimelineItem,
    },
}).$mount('#vue-root');
